import { render, staticRenderFns } from "./PackageAdd.vue?vue&type=template&id=7fb7b27d&scoped=true"
import script from "./PackageAdd.vue?vue&type=script&lang=js"
export * from "./PackageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7b27d",
  null
  
)

export default component.exports